module.exports = __webpack_public_path__ + "media/images/ic-masonry-white-c47266d372e2ebf22f9795200269dc94.svg";